import { Component } from '@angular/core';
import { EJobState } from '../jobs/job-state.enum';
import { EJobType } from '../jobs/job-type.enum';

@Component({
  selector: 'alerts',
  templateUrl: 'alerts.component.html',
  styleUrls: ['alerts.component.scss']
})
export class AlertsComponent {

  public jobStates = EJobState;
  public jobType = EJobType.Alarm;
}
